"use client";

import createIcon from './util/createIcon';
export default createIcon('M7.03 13.92H11.03V5L13.04 4.97V13.92H17.03L12.03 18.92Z', 'ArrowDownThin');